import { Box } from 'reflexbox';
import styled from 'styled-components';

const MiniProgressBarTrack = styled(Box)`
	background-color: #efeef9;
	border-radius: 4px;
	overflow: hidden;
`;

const MiniProgressBarProgress = styled(Box)`
	background-color: ${(props) => props.theme.colors.primary};
	border-radius: 4px 0 0 4px;
`;

export function MiniProgressBar({
	value,
	total,
	width,
}: {
	value: number;
	total: number;
	width?: number | string;
}) {
	const pct = total > 0 ? Math.min(100, Math.max(0, (value / total) * 100)) : 0;

	return (
		<MiniProgressBarTrack width={width ?? 50} height={4}>
			<MiniProgressBarProgress width={`${pct}%`} height={4} />
		</MiniProgressBarTrack>
	);
}
